/* eslint-disable angular/no-service-method */

angular.
module("dx.webapp.event").
service("dxEvent", function eventService(
	$http,

	RoleTypeEnum,
	dxSession
) {
	"use strict";

	this.create = function create(eventName, metadata) {
		var allowedRoles = [RoleTypeEnum.TEACHER, RoleTypeEnum.ADMIN, RoleTypeEnum.ACCOUNTMANAGER];
		if (allowedRoles.indexOf(dxSession.getRole().roleType) === -1) {
			return null;
		}

		if (metadata) {
			for (var i = 0; i < metadata.length; i++) {
				metadata[i].value = metadata[i].value.toString();
			}
		}

		var request = {
			eventName: eventName,
			metadata: metadata,
		};

		return $http.post("/event/", request);
	};
});
